/* Site-Specific JavaScript */

// IR Integrated JS Fixes

    // Fixes mobile menu toggle open / close - mimics main site setup
    document.addEventListener('DOMContentLoaded', function() {
        const menuButton = document.querySelector('.wp-block-navigation__responsive-container-open');
        const menuContainer = document.querySelector('.wp-block-navigation__responsive-container');
        const menuDialog = document.querySelector('.wp-block-navigation__responsive-dialog');
        const closeButton = document.querySelector('.wp-block-navigation__responsive-container-close');
        
        // Only add event listeners if the required elements exist
        if (menuButton && menuContainer && menuDialog && closeButton) {
            function openMenu() {
                menuContainer.classList.add('has-modal-open', 'is-menu-open');
                menuDialog.setAttribute('aria-modal', 'true');
                menuDialog.setAttribute('role', 'dialog');
                menuDialog.setAttribute('aria-label', 'Menu');
                
                // Add in-view class to all relevant elements
                const elementsToAnimate = menuContainer.querySelectorAll('*');
                elementsToAnimate.forEach(el => el.classList.add('in-view'));
                
                // Prevent body scroll – keep previous overflow value so we can restore it
                const previousOverflow = document.body.style.overflow;
                document.body.dataset.prevOverflow = previousOverflow;
                document.body.style.overflow = 'hidden';
            }
            
            function closeMenu() {
                menuContainer.classList.remove('has-modal-open', 'is-menu-open');
                menuDialog.removeAttribute('aria-modal');
                menuDialog.removeAttribute('role');
                menuDialog.removeAttribute('aria-label');
                
                // Remove in-view class from all elements
                const elementsToAnimate = menuContainer.querySelectorAll('*');
                elementsToAnimate.forEach(el => el.classList.remove('in-view'));
                
                // Restore body scroll
                document.body.style.overflow = document.body.dataset.prevOverflow || '';
                delete document.body.dataset.prevOverflow;
            }
            
            // Open menu
            menuButton.addEventListener('click', openMenu);
            
            // Close menu
            closeButton.addEventListener('click', closeMenu);
            
            // Close menu when clicking outside
            menuContainer.addEventListener('click', (e) => {
                if (!menuDialog.contains(e.target)) {
                    closeMenu();
                }
            });
            
            // Close menu on escape key
            document.addEventListener('keydown', function(e) {
                if (e.key === 'Escape' && menuContainer.classList.contains('has-modal-open')) {
                    closeMenu();
                }
            });
        }

        // Handle submenu hover states
        const submenuItems = document.querySelectorAll('.wp-block-navigation-item.has-child');
        submenuItems.forEach(item => {
            const toggle = item.querySelector('.wp-block-navigation-submenu__toggle');
            const submenu = item.querySelector('.wp-block-navigation__submenu-container');
            if (!toggle || !submenu) return; // defensive guard

            item.addEventListener('mouseenter', () => {
                toggle.setAttribute('aria-expanded', 'true');
                submenu.style.display = 'block';
            });
            
            item.addEventListener('mouseleave', () => {
                toggle.setAttribute('aria-expanded', 'false');
                submenu.style.display = 'none';
            });
        });
    });